var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.175 3.775v6.275H17.9V7.675L14.15 11.4q.475.7.713 1.475.237.775.237 1.625 0 2.35-1.65 4t-4 1.65q-2.35 0-3.987-1.65-1.638-1.65-1.638-4t1.638-4Q7.1 8.85 9.45 8.85q.825 0 1.612.237.788.238 1.463.713L16.3 6.05h-2.4V3.775ZM9.45 11.15q-1.4 0-2.375.975Q6.1 13.1 6.1 14.5t.975 2.375q.975.975 2.375.975t2.388-.975q.987-.975.987-2.375t-.987-2.375q-.988-.975-2.388-.975Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.0a0e5b4f238955b9edfc1bda614d739f.svg";
export { ForwardRef as ReactComponent };